class ApiService {
  private baseUrl: string;
  private defaultOptions: RequestInit;
  constructor() {
    this.baseUrl = window.JobBoardViewData?.[0]?.data?.ajax_url || '';
    this.defaultOptions = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    };
  }
  private appendFormData(formData: FormData, data: any, parentKey = ''): void {
    if (data instanceof File) {
      formData.append(parentKey, data);
    } else if (Array.isArray(data)) {
      data.forEach((value, idx) => {
        this.appendFormData(formData, value, `${parentKey}[${idx}]`);
      });
    } else if (data && typeof data === 'object') {
      Object.entries(data).forEach(([key, value]) => {
        const nextKey = parentKey ? `${parentKey}[${key}]` : key;
        this.appendFormData(formData, value, nextKey);
      });
    } else if (data !== undefined && data !== null) {
      formData.append(parentKey, String(data));
    }
  }
  async post<T>(
    action: string, 
    data: Record<string, any> = {}, 
    customNonce?: string
  ): Promise<T> {
    const formData = new FormData();
    formData.append('action', action);
    const nonce = this.getNonce(action, customNonce);
    if (nonce) {
      formData.append('_wpnonce', nonce);
    }
    this.appendFormData(formData, data);
    try {
      const response = await fetch(this.baseUrl, {
        ...this.defaultOptions,
        body: formData
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.message || 'Error en la petición');
      }

      if (!result.success) {
        throw new Error(result.message || 'Error en la respuesta del servidor');
      }

      return result;
    } catch (error) {
      console.error('Error en API call:', error);
      throw error;
    }
  }
  private getNonce(action: string, customNonce?: string): string | null {
    if (customNonce) return customNonce;

    const nonces = window.JobBoardViewData?.[0]?.data?.nonces;
    if (!nonces) {
      console.warn('No se encontraron nonces en JobBoardViewData');
      return null;
    }

     const nonceMap: Record<string, string> = {
      'get_boards_vacant_description': nonces.get_boards_vacant_description || nonces.default,
      'get_boards_vacant_counts': nonces.get_boards_vacant_counts || nonces.default,
      'create_vacancy': nonces.create_vacancy || nonces.default,
      'duplicate_vacancy': nonces.duplicate_vacancy || nonces.default,
    };

    return nonceMap[action] || nonces.default || null;
  }
}

export const apiService = new ApiService();
